<template>
  <div class="table">
    <table class="table table-sm horizon" ref="table">
      <tbody>
        <tr>
          <th>미터금액</th>
          <th v-if="isShowHipassFare">통행요금</th>
          <th>호출요금</th>
          <th v-if="isShowAddFare">추가금액</th>
          <th v-if="isShowTotalFare">합계금액</th>
          <th>총 운행거리</th>
          <th>영업거리</th>
          <th>영업시간</th>
        </tr>
        <tr>
          <td>{{ elements.allPayFare ? insertComma(elements.allPayFare) : elements.allPayFare}}원</td>
          <td v-if="isShowHipassFare">{{ elements.allHipassFare ? insertComma(elements.allHipassFare) : elements.allHipassFare}}원</td>
          <td>{{ elements.allCallFare ? insertComma(elements.allCallFare) : elements.allCallFare}}원</td>
          <td v-if="isShowAddFare">{{ elements.allAddFare ? insertComma(elements.allAddFare) : elements.allAddFare}}원</td>
          <td v-if="isShowTotalFare">{{ elements.allFare ? insertComma(elements.allFare) : elements.allFare}}원</td>
          <td>{{elements.allDist ? insertComma(elements.allDist) : elements.allDist}}km</td>
          <td>{{elements.allWorkDist ? insertComma(elements.allWorkDist) : elements.allWorkDist}}km</td>
          <td>{{elements.allWorkTime}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {ref} from "vue";
import { insertComma } from "@/components/tacho/common/CommonFunc"

const isShowHipassFare = ref(true)
const isShowAddFare = ref(true)
const isShowTotalFare = ref(true)

export default {
  name: "MonthlyTripTotalDataTable",
  props: {
    elements: Object,
    selectAutoScroll: Function,
    onSelected: Function,
    onDoubleClick: Function
  },
  setup(props) {
    const scroll = ref("");

    const autoScroll = () => (props.selectAutoScroll !== undefined && scroll.value.scrollHeight - scroll.value.scrollTop <= scroll.value.clientHeight) ? props.selectAutoScroll() : "";

    return {
      scroll, autoScroll, insertComma, isShowHipassFare, isShowAddFare, isShowTotalFare
    }
  }
}
</script>

<style scoped>
* {
  font-size: 0.8rem;
}
/*
th {
  background-color: #e3e3e3 !important;
  border-color: #c9c8c8 !important;
  border-top: 1px solid #c9c8c8;
  border-bottom: 1px solid #c9c8c8;
  font-weight: 500;
  width: 6rem;
}
td {
  border-top: 1px solid #c9c8c8;
  border-bottom: 1px solid #c9c8c8;
  width: 10rem;
}
*/

</style>
